import React from 'react';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer/Footer';
import OffWrap from '../../components/Layout/Header/OffWrap';
import SearchModal from '../../components/Layout/Header/SearchModal';
import Newsletter from '../../components/Common/Newsletter';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import ServiceMain from './ServiceMain';


// Image
import Logo from '../../assets/img/logo/dark-logo.png';
import footerLogo from '../../assets/img/logo/lite-logo.png';

import bannerbg from '../../assets/img/breadcrumbs/2.jpg';

const Services = () => {

    return (
        <React.Fragment>
            <OffWrap />
            <Header
                TopBar='enable'
                emailAddress='admin@firebirdllc.com'
                Location='601 S 10th St., #104, Las Vegas, Nevada 89101'
                parentMenu='home'
            />
            <div className='pageOffset'>
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="Service"
                    pageName="Service"
                    breadcrumbsImg={bannerbg}
                />
                {/* breadcrumb-area-start */}

                {/* About Main */}
                <ServiceMain />
                {/* About Main */}

                {/* <Newsletter
                sectionClass="rs-newsletter style1 orange-color mb--90 sm-mb-0 sm-pb-70"
                titleClass="title mb-0 white-color"
            /> */}
            </div>
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
        </React.Fragment>
    );
}

export default Services;